/**
 * Výčtový typ popisující druhy práv, které je možné požadovat po serveru vyhodnotit
 */
export enum ClassItemRightTypes {
    all = 0, // TODO-rites: změnit z nuly; zároveň s taskem 19921 - úprava na serveru
    visible = 1 << 0,
    enabled = 1 << 1,
    required = 1 << 2,
    recommended = 1 << 3,
    postponedRequired = 1 << 4,
    openAsEnabled = 1 << 5,
    allRequired = required | recommended | postponedRequired,
}

/**
 * Informace o podminkach pro komponenty
 */
export interface IRightConditionItem {
    id: string;
    value: string;
    isStatic?: boolean;
}

// ReSharper disable InconsistentNaming

export enum ClassItemType {
    Attribute,
    Method,
}

/**
 * Množina implicitních práv prvků daného objektu práv pro jednotlivé role
 * */
export interface IRolesDefaultRightsResult {
    /**
     * Název prvku práv (třída, formulář, systémová operace
     */
    readonly name: string;
    /**
     * Pole implicitních práv za jednotlivé role
     */
    readonly rights: IRoleImplicitRights[];
}

/**
 * Informace o implicitním nastavení práv prvků dané role
 */
export interface IRoleImplicitRights {
    /**
     * ID role
     */
    readonly id: string;
    /**
     * Implicitní viditelnost
     */
    readonly visible: boolean;
    /**
     * Implicitní povolení editace
     */
    readonly enabled: boolean;
    /**
     * Implicitní povinnost
     */
    readonly required: boolean;
    /**
     * Implicitní odložená povinnost
     */
    readonly postponedRequired: boolean;
    /**
     * Implicitní nastavení doporučenosti prvku
     */
    readonly recommended: boolean;
    /**
     * Implicitní povolení spuštění metody
     */
    readonly executable: boolean;
    /**
     * Implicitní povolení spuštění metody v editačním režimu
     */
    readonly executableInEdit: boolean;
    /**
     * Indikátor, zda se jedná o nastavení načtenné z DB (false) nebo vytvořené serverem podle daných pravidel (true)
     */
    readonly notInDB: boolean;
}

export interface IClassItem {
    name: string;
    type: ClassItemType;
}

/**
 * Informace o vyhodnocených právech prvku
 */
export interface IClassItemRights {
    /**
     * Jméno prvku
     */
    Name: string;

    /**
     * Typ prvku
     */
    Type: ClassItemType | null;

    /**
     * Hodnota práva přistupnosti
     */
    Enabled?: boolean;

    /**
     * Hodnota práva povinnosti
     */
    Required?: boolean;

    /**
     * Hodnota doporucenosti
     */
    Recommended?: boolean;

    /**
     * Hodnota práva odložené povinnosti
     */
    PostponedRequired?: boolean;

    /**
     * Hodnota práva viditelnosti
     */
    Visible?: boolean;

    /**
     * Výsledek vyhodnocení práv zda má být povoleno otevření formu jako editovatelného
     */
    OpenAsEnabled?: boolean;
}

/**
 * Objekt výsledku vyhodnocení práv prvku na úrovni třídy pro vracení klientovi
 */
export interface IClassItemRightsResult {
    /**
     * Běžný cyklus OWObject, na kterém byly vyhodnoceny práva prvků
     */
    AttrChangeCycle: number;

    /**
     * Seznam vyhodocených práv prvků
     */
    ItemRights: Array<IClassItemRights>;
}

/**
 * Vyhodnocena podminka
 */
export interface IEvaluatedConditionResult {
    ID: string;
    Result: boolean;
    ExceptionText?: string;
}

/**
 * Udává, která práva jsou pevně zakázaná
 */
export interface IFirmlyDisabledRights {
    /** Právo editace je zakázané */
    readonly edit: boolean;
    /** Právo vkládání je zakázané */
    readonly insert: boolean;
    /** Právo mazání je zakázané */
    readonly delete: boolean;
    /** Právo zobrazení je zakázané */
    readonly view: boolean;
    /** Právo validace je zakázané */
    readonly validate: boolean;
}

/**
 * Obsahuje pole rolí, které umožní čtení, editaci a mazání dané třídy na rozhraní serveru
 */
export interface IClassInterfaceManipulativeRoles {
    /**Seznam id rolí, které umožňují přístup k objektu */
    readonly roleIds: string[];
    /**Seznam id rolí umožňující editaci */
    readonly editRoleIds: string[];
    /**Seznam id rolí umožňující mazání */
    readonly deleteRoleIds: string[];
}
